export default [
  {
    title: 'Dashboards',
    icon: 'HomeIcon',
    tag: '1',
    tagVariant: 'light-warning',
    children: [
      {
        title: 'Main',
        route: 'dashboard-ecommerce',
        action: 'read',
        resource: 'Dashboard-Ecommerce',
      },
      // {
      //   title: 'Analytics',
      //   route: 'dashboard-analytics',
      //   action: 'read',
      //   resource: 'Dashboard-Analytics',
      // },
    ],
  },
]
